<!-- NPS DIALOG -->
<!-- ══ NPS FEEDBACK DIALOG ══ -->
<div class="nps-overlay" *ngIf="showNpsDialog">
  <div class="nps-dialog" role="dialog" aria-modal="true">

    <!-- Logo -->
    <div class="nps-logo-row">
      <img src="assets/delogo.png" style="width: 50px;">
      <div>
        <div class="nps-brand">{{ hospitalName }}</div>
        <div class="nps-tagline">{{ npsTagline }}</div>
      </div>
    </div>

    <!-- Wave + heart icon -->
    <div class="nps-wave-wrap">
      <svg width="100%" height="60" viewBox="0 0 500 60" preserveAspectRatio="none" fill="none">
        <path d="M0 30 C80 8,160 52,250 30 C340 8,420 52,500 30" stroke="#b5d6f5" stroke-width="2" fill="none"/>
      </svg>
      <div class="nps-heart-circle">
        <img src="assets/hBord.png" style="width: 35px;">
      </div>
    </div>

    <p class="nps-question">
      {{ npsQuestion }}
    </p>

    <!-- Score scale -->
    <div class="nps-scale-labels">
      <span class="nps-least">{{ npsScaleLowLabel }}</span>
      <span class="nps-most">{{ npsScaleHighLabel }}</span>
    </div>
    <div class="nps-score-row">
      <button *ngFor="let n of npsScores" class="nps-score-btn" [ngClass]="'nps-s' + n" [class.nps-active]="npsScore === n" (click)="selectNpsScore(n)">
        {{ n }}
      </button>
    </div>

    <!-- Patient Name -->
    <div class="nps-field">
      <label class="nps-label">Name 
      </label>
      <div class="nps-input-box" [class.nps-input-error]="npsNameError">
        <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="#9ca3af" stroke-width="1.8">
          <circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke-linecap="round"/>
        </svg>
        <input type="text" [(ngModel)]="npsPatientName" placeholder="Enter your name" (input)="npsNameError = false"/>
      </div>
       <span class="nps-error-msg" *ngIf="npsNameError"> {{ npsNameErrorMsg }} </span>
    </div>

    <!-- Mobile / Email -->
    <div class="nps-field">
      <label class="nps-label">Mobile / Email</label>
      <div class="nps-input-box" [class.nps-input-error]="npsContactError">
        <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="#9ca3af" stroke-width="1.8">
          <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8Z" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <input type="text" [(ngModel)]="npsContact" placeholder="Enter mobile number or email ID" (input)="onNpsContactInput($event)"/>
      </div>
        <span class="nps-error-msg" *ngIf="npsContactError">{{ npsContactErrorMsg }}</span>
    </div>

    <!-- Comments -->
    <div class="nps-field">
      <label class="nps-label">Please add more details <span class="nps-opt">(optional)</span></label>
      <p class="nps-opt-sub">Your feedback helps us improve.</p>
      <div class="nps-textarea-box">
        <textarea [(ngModel)]="npsComments" placeholder="Type your comments here..."
                  (input)="onNpsCommentInput()" maxlength="150"></textarea>
      </div>
      
      <span class="nps-max-words">Maximum 150 words 
        <div class="nps-wc">{{ npsCharCount }} / 150</div>
      </span>
    </div>

    <!-- Submit button -->
    <button class="nps-submit-btn" [disabled]="!npsScore" (click)="submitNpsFeedback()">
      Submit Feedback
    </button>

    <div class="nps-thank-line">
      <svg width="26" height="26" fill="none" viewBox="0 0 24 24" stroke="#0066cc" stroke-width="2">
      
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M12 3L5 6V11C5 16 8.4 20.4 12 21C15.6 20.4 19 16 19 11V6L12 3Z" />
      
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12L11 14L15 10" />
      
      </svg>
      Thank you for your feedback!
    </div>
  </div>
</div>

<!-- ══ POST-SUBMIT CONFIRMATION DIALOG ══ -->
<div class="nps-overlay" *ngIf="showNpsConfirmDialog">
  <div class="nps-confirm-dialog" role="dialog" aria-modal="true">
    <div class="nps-confirm-icon">
      <svg width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="#22a05e" stroke-width="1.6">
        <circle cx="12" cy="12" r="10"/>
        <path d="M8 12l3 3 5-5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <h2 class="nps-confirm-title">Feedback Submitted!</h2>
    <p class="nps-confirm-msg">
      {{ npsThanks }}
    </p>
    <div class="nps-confirm-actions">
      <button class="nps-confirm-cancel" (click)="npsGoBack()">Go Back</button>
      <button class="nps-confirm-continue" (click)="npsContinueToComplaint()">Continue</button>
    </div>
  </div>
</div>
<!-- NPS DIALOG -->

<!-- Lightweight loading state while GET /questions/{firmName} is in flight.
     Deliberately reuses the existing header markup/classes only, no new CSS,
     so there is no layout jump once the real chat-container renders. -->
<div class="chat-container" *ngIf="configLoading && !isValidUid">
  <div class="header">
    <span class="header-title">{{ feedbackUiTitle }}</span>
  </div>
</div>

<div class="chat-container" *ngIf="isValidUid">
  <div class="header">
    <span class="back-button" (click)="goBack()"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
    <span class="header-title">{{ feedbackUiTitle }}</span>
  </div>

  <div class="messages" #messageContainer>
    <div *ngFor="let message of messages; let first = first; let last = last" 
         class="message-wrapper"
         [attr.data-last-message]="last ? '' : null">
      <div class="message-container" [ngClass]="{'user-container': message.type === 'user'}">
        <div class="message" [ngClass]="{'bot-message': message.type === 'bot', 'user-message': message.type === 'user'}">
          <span class="message-content">{{ message.content }}</span>
          <span class="message-timestamp">{{ (isDynamicMode && first ? greetingTime : message.timestamp) | date:'h:mm a' }}</span>
        </div>
      </div>

      <div *ngIf="message.type === 'bot'" class="message-options">
        <div *ngIf="message.options?.length && !message.isMultiSelect" class="category-grid">
          <button *ngFor="let option of message.options" 
                  class="category-button"
                  [class.selected]="activeCategory === option.text"
                  [disabled]="isChatEnded"
                  (click)="option.dynamicCategory ? selectDynamicCategory(option.dynamicCategory) : selectOption(option, false)">
            <img *ngIf="option.imageUrl" [src]="option.imageUrl" [alt]="option.text" class="category-icon">
            <span class="category-text">{{ option.text }}</span>
          </button>
        </div>

        <div *ngIf="message.isMultiSelect" class="checkbox-options">
          <div *ngFor="let option of message.options" class="checkbox-option">
            <input type="checkbox" style="cursor: pointer;"
                   [id]="option.id"
                   [checked]="selectedOptions.indexOf(option.text) > -1"
                   [disabled]="isCategorySelectionDisabled"
                   (change)="selectOption(option, true)">
            <label [for]="option.id" style="pointer-events: none">{{ option.text }}</label>
          </div>
          
          <div *ngIf="showOthersTextarea" class="others-textarea-container">
            <textarea maxlength="500"
              [(ngModel)]="othersSpecifyText"
              placeholder="Please specify the issue..."
              class="others-textarea"
              [disabled]="isCategorySelectionDisabled">
            </textarea>
          </div>
          
          <button *ngIf="selectedOptions.length > 0 && !isCategorySelectionDisabled" 
            class="submit-button"
            [disabled]="showOthersTextarea && !othersSpecifyText.trim()" 
            (click)="confirmIssues()">
            Next
          </button>
        </div>

        <!-- ══ DYNAMIC (API-DRIVEN) QUESTION RENDERING ══
             Only ever active for message === last message, mirroring the
             existing pattern used by showDetailsInput/showPatientForm above.
             Reuses the same CSS classes as the legacy blocks above/the NPS
             dialog so it stays visually identical without any new styles. -->
        <ng-container *ngIf="message.dynamicQuestion && message === messages[messages.length - 1]">

          <!-- multi_choice -->
          <div *ngIf="message.dynamicQuestion.type === 'multi_choice'" class="checkbox-options">
            <div *ngFor="let opt of message.dynamicQuestion.options" class="checkbox-option">
              <input type="checkbox" style="cursor: pointer;"
                     [id]="message.dynamicQuestion.id + '-' + opt"
                     [checked]="isDynamicMultiOptionActive(opt)"
                     (change)="toggleDynamicMultiOption(opt)">
              <label [for]="message.dynamicQuestion.id + '-' + opt" style="pointer-events: none">{{ opt }}</label>
            </div>

            <div *ngIf="dynamicShowOthersInput" class="others-textarea-container">
              <textarea maxlength="500"
                [(ngModel)]="dynamicOthersText"
                [placeholder]="(message.dynamicQuestion.otherLabel || 'Please specify') + '...'"
                class="others-textarea">
              </textarea>
            </div>

            <button *ngIf="dynamicSelectedOptions.length > 0"
              class="submit-button"
              [disabled]="dynamicShowOthersInput && !dynamicOthersText.trim()"
              (click)="confirmDynamicMultiAnswer()">
              Next
            </button>
          </div>

          <!-- single_choice -->
          <div *ngIf="message.dynamicQuestion.type === 'single_choice'" class="category-grid">
            <button *ngFor="let opt of message.dynamicQuestion.options"
                    class="category-button"
                    (click)="selectDynamicSingleOption(opt)">
              <span class="category-text">{{ opt }}</span>
            </button>
          </div>

          <!-- rating -->
          <div *ngIf="message.dynamicQuestion.type === 'rating'">
            <div class="nps-scale-labels">
              <span class="nps-least">{{ npsScaleLowLabel }}</span>
              <span class="nps-most">{{ npsScaleHighLabel }}</span>
            </div>
            <div class="nps-score-row">
              <button *ngFor="let n of npsScores" class="nps-score-btn" [ngClass]="'nps-s' + n"
                      [class.nps-active]="dynamicRatingValue === n"
                      (click)="selectDynamicRating(n)">
                {{ n }}
              </button>
            </div>
          </div>

          <!-- text / textarea -->
          <div *ngIf="message.dynamicQuestion.type === 'text' || message.dynamicQuestion.type === 'textarea'"
               class="details-input-container">
            <textarea [(ngModel)]="dynamicTextAnswer" maxlength="500"
                      placeholder="Type your answer..."
                      class="details-input"></textarea>
            <button (click)="submitDynamicText()"
                    class="submit-button"
                    [disabled]="message.dynamicQuestion.required && !dynamicTextAnswer.trim()">
              Send
            </button>
          </div>

        </ng-container>
        
        <div *ngIf="showMiscDetailsInput && message === messages[messages.length - 1]" 
            class="details-input-container">
          <textarea [(ngModel)]="additionalDetails" maxlength="500"
                    placeholder="Please provide more details about your issue..."
                    class="details-input"></textarea>
          <button (click)="submitDetails()"
                  class="submit-button"
                  [disabled]="!additionalDetails.trim()">
            Send
          </button>
        </div>

    <!-- First yes/no -->
    <div *ngIf="message.showYesNo" class="yes-no-options">
      <button class="option-button" 
              [ngClass]="{'active-button': isYesNoButtonActive('Yes')}"
              [disabled]="isYesNoClicked"
              (click)="handleYesNo('Yes', message.isEndFlow)">Yes</button>
      <button class="option-button" 
              [ngClass]="{'active-button': isYesNoButtonActive('No')}"
              [disabled]="isYesNoClicked"
              (click)="handleYesNo('No', message.isEndFlow)">No</button>
    </div>

    <!-- Last yes/no -->
    <div *ngIf="message.showLastYesNo" class="yes-no-options">
      <button class="option-button" 
              [ngClass]="{'active-button': isLastYesNoButtonActive('Yes')}"
              [disabled]="isLastYesNoClicked"
              (click)="handleLastYesNo('Yes', message.isEndFlow)">Yes</button>
      <button class="option-button" 
              [ngClass]="{'active-button': isLastYesNoButtonActive('No')}"
              [disabled]="isLastYesNoClicked"
              (click)="handleLastYesNo('No', message.isEndFlow)">No</button>
    </div>

      <div *ngIf="showDetailsInput && message === messages[messages.length - 1]" 
           class="details-input-container">
        <textarea [(ngModel)]="additionalDetails" maxlength="500"
                  placeholder="Type more details..."
                  class="details-input"></textarea>
        <button (click)="submitDetails()"
                class="submit-button"
                [disabled]="!additionalDetails.trim()">
          Send
        </button>
      </div>

      <form *ngIf="showPatientForm && !useDynamicDetailsForm && message === messages[messages.length - 1]" 
            [formGroup]="patientDetailsForm"
            class="details-form"
            (ngSubmit)="submitPatientForm()">
        <input formControlName="wardNo"
              placeholder="Ward No / Bed No"
              class="form-input">
        <span class="error-message"
              *ngIf="patientDetailsForm.get('wardNo')?.invalid && patientDetailsForm.get('wardNo')?.touched">
          Ward No / Bed No is required
        </span>

        <input formControlName="patientName"
              placeholder="Patient Name (Optional)"
              class="form-input">
        
        <input formControlName="contactInfo"
              placeholder="Email or Phone Number (Optional)"
              class="form-input"
              type="text">

        <button type="submit"
                class="submit-button"
                [disabled]="patientDetailsForm.invalid">
          Submit
        </button>
      </form>

      <!-- ══ CONFIG-DRIVEN DETAILS FORM ══
           One input per detail question from GET /questions/{firm}, so a firm
           without a ward question simply has no ward input. Same CSS classes
           as the hospital form above. -->
      <form *ngIf="showPatientForm && useDynamicDetailsForm && message === messages[messages.length - 1]"
            class="details-form"
            (ngSubmit)="submitDynamicDetailsForm()">
        <ng-container *ngFor="let question of detailQuestions">
          <input [(ngModel)]="detailValues[question.id]"
                 [name]="'detail-' + question.id"
                 (input)="onDetailInput(question)"
                 [placeholder]="detailPlaceholder(question)"
                 class="form-input"
                 type="text">
          <span class="error-message" *ngIf="detailErrors[question.id]">{{ detailErrors[question.id] }}</span>
        </ng-container>

        <button type="submit" class="submit-button">
          Submit
        </button>
      </form>
    </div>
  </div>
</div>
</div>

<!-- Communication Preferences Popup -->
<div class="popup-overlay" *ngIf="showWhatsAppPopup" (click)="closeWhatsAppPopup()">
  <div class="popup-content" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h3>Communication Preferences</h3>
      <button class="close-button" (click)="closeWhatsAppPopup()">&times;</button>
    </div>
    
    <div class="popup-body">
      <p class="popup-message">Would you like to receive updates about your complaint?</p>
      
      <!-- Contact Information Section -->
      <div class="contact-info-section">
        <div class="form-group">
          <label for="patientName">Patient Name</label>
          <input 
            type="text" 
            id="patientName"
            [(ngModel)]="communicationName"
            placeholder="Enter patient name"
            class="popup-input"
            [class.error-input]="showNameError">
        </div>
        
        <!-- Single Contact Field - Auto-detects Email or Phone -->
        <div class="form-group">
          <label for="contactInfo">Email or Phone Number (Optional)</label>
          <input 
            type="text" 
            id="contactInfo"
            [(ngModel)]="communicationContact"
            (input)="onContactInputChange()"
            placeholder="Enter email address or 10-digit phone number"
            class="popup-input"
            [class.error-input]="showContactError">
          <span class="error-message" *ngIf="showContactError">{{ contactErrorMessage }}</span>
          <span class="input-hint" [ngClass]="{'error-hint': communicationMethod !== 'email' && communicationMethod !== 'sms'
            }" *ngIf="communicationContact && !showContactError">
            <i class="fa" [ngClass]="{
                'fa-check-circle': communicationMethod === 'email' || communicationMethod === 'sms',
                'fa-exclamation-circle': communicationMethod !== 'email' && communicationMethod !== 'sms'
              }"></i>
            {{
            communicationMethod === 'email'
            ? 'Email detected - Updates will be sent via Email'
            : communicationMethod === 'sms'
            ? 'Phone detected - Updates will be sent via SMS'
            : 'Enter valid email or phone number'
            }}
          </span>
          
        </div>
      </div>
      
      <p class="info-text" *ngIf="communicationMethod !== 'none' && communicationContact.trim()">
        <i class="fa fa-info-circle"></i> 
        You will receive complaint status updates via {{ communicationMethod === 'sms' ? 'SMS' : 'Email' }}.
      </p>
      
      <p class="info-text-secondary" *ngIf="!communicationContact.trim()">
        <i class="fa fa-info-circle"></i> 
        Leave contact field empty if you don't want to receive updates.
      </p>
    </div>
    
    <div class="popup-footer">
      <button class="popup-button primary" (click)="submitCommunicationPreference()">
        {{ communicationContact.trim() ? 'Confirm' : 'Continue Without Updates' }}
      </button>
    </div>
  </div>
</div>

<div class="not-found-container" *ngIf="!configLoading && !isValidUid">
  <img src="assets/3793096.jpg" alt="Page Not Found" class="not-found-image">
  <h2>Oops! Page Not Found</h2>
  <p>The page you're looking for wasn't found. Please scan the QR code again to proceed.</p>
</div>